import { Helmet } from 'react-helmet';

const MainHelmet = ({ title, slug, keywords, description }) => {
  return (
    <Helmet>
      <title>{title} - alter-text Studio</title>
      <link rel="canonical" href={`https://altertext.studio/work/${slug}`} />
      <meta name="keywords" content={keywords} />
      <meta name="description" content={description} />
      <link
        rel="apple-touch-icon"
        sizes="57x57"
        href="https://www.altertext.studio/favicon/apple-icon-57x57.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="60x60"
        href="https://www.altertext.studio/favicon/apple-icon-60x60.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="72x72"
        href="https://www.altertext.studio/favicon/apple-icon-72x72.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="76x76"
        href="https://www.altertext.studio/favicon/apple-icon-76x76.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="114x114"
        href="https://www.altertext.studio/favicon/apple-icon-114x114.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="120x120"
        href="https://www.altertext.studio/favicon/apple-icon-120x120.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="144x144"
        href="https://www.altertext.studio/favicon/apple-icon-144x144.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="152x152"
        href="https://www.altertext.studio/favicon/apple-icon-152x152.png"
      />
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="https://www.altertext.studio/favicon/apple-icon-180x180.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href="https://www.altertext.studio/favicon/android-icon-192x192.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="https://www.altertext.studio/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="96x96"
        href="https://www.altertext.studio/favicon-96x96.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="https://www.altertext.studio/favicon-16x16.png"
      />
      <link rel="manifest" href="https://www.altertext.studio/manifest.json" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta
        name="msapplication-TileImage"
        content="https://www.altertext.studio/ms-icon-144x144.png"
      />
      <meta name="theme-color" content="#ffffff" />
    </Helmet>
  );
};

export default MainHelmet;
